export enum SupportPlatform {
  NB = 'NB',
  FT = 'FT',
}
